var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54962 4.84121L4.01233 3.47119L20.3803 21.1012L18.9176 22.4712L2.54962 4.84121Z",
    fill: "#B9BDC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55727 9.44366C8.61002 10.1784 7.99994 11.3304 7.99994 12.6254C7.99994 14.8443 9.7908 16.6431 11.9999 16.6431C13.189 16.6431 14.2569 16.122 14.9895 15.2948L13.6157 13.815C13.2505 14.3185 12.6602 14.6431 11.9999 14.6431C10.9037 14.6431 9.99994 13.7481 9.99994 12.6254C9.99994 11.9047 10.3724 11.2778 10.9292 10.9213L9.55727 9.44366Z",
    fill: "#B9BDC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9324 13.3648C15.9767 13.1251 15.9999 12.878 15.9999 12.6254C15.9999 10.4065 14.2091 8.60778 11.9999 8.60778C11.8445 8.60778 11.6911 8.61669 11.5402 8.63402L15.9324 13.3648Z",
    fill: "#B9BDC6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59568 7.33083C4.35293 9.24406 1.99994 12.4999 1.99994 12.4999C1.99994 12.4999 6.71825 19.0286 11.9999 19.0286C13.8377 19.0286 15.5272 18.3513 16.9737 17.432L15.615 15.9685C14.5553 16.5829 13.3357 17.0197 11.9999 17.0197C8.3054 17.0197 5.3695 13.6915 4.38089 12.4991C5.07126 11.6657 6.7103 9.78898 8.8993 8.73497L7.59568 7.33083Z",
    fill: "#B9BDC6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2603 14.7951C18.2995 13.9136 19.0713 12.9885 19.4999 12.4712C18.5111 11.2786 15.6945 7.98001 11.9999 7.98001C11.662 7.98001 11.3305 8.00772 11.0064 8.05899L9.49403 6.43005C10.3027 6.14267 11.1439 5.97118 11.9999 5.97118C17.7182 5.97118 21.9999 12.4712 21.9999 12.4712C21.9999 12.4712 20.708 14.4498 18.5956 16.2334L17.2603 14.7951Z",
    fill: "#B9BDC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharp);
export default __webpack_public_path__ + "static/media/sharp.345c2d5b9f505cbf59cf4ee6a01a6b16.svg";
export { ForwardRef as ReactComponent };